module.exports = __webpack_public_path__ + "1f423fdabb448a5727ed0fdfd2dc0a01.png";